var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.secondary.id === 8)?_c('tr-analysis-pd-graph'):_vm._e(),(_vm.secondary.id === 9)?_c('tr-analysis-dga-graph'):_vm._e(),(_vm.secondary.id === 10)?_c('tr-analysis-locus-graph'):_vm._e(),(_vm.secondary.id === 11)?_c('tr-analysis-losses-graph'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }